
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Individual from './Individual';
import Couples from './Couple';
import Children from './Children';
import Footer from '../Footer/Footer';
import Accordion from 'react-bootstrap/Accordion';

function Services() {
    return (
        <>
            <Container>
                <Row >
                    <Col lg={4} style={{paddingTop:"30px"}}>
                        <Children />
                    </Col>
                    <Col lg={4} style={{paddingTop:"30px"}}>
                        <Individual />
                    </Col>
                    <Col lg={4} style={{paddingTop:"30px"}}>
                        <Couples />
                    </Col>
                </Row>
                <Row style={{paddingTop:"30px"}}>
                    <Col lg={12}>
                        <Accordion defaultActiveKey="0">
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>SERVICES PROVIDED</Accordion.Header>
                                <Accordion.Body>
                                    <ul>
                                        <li>Sleep problems</li>
                                        <li>Stress related conditions</li>
                                        <li>Addiction disorders</li>
                                        <li>Interpersonal conflicts</li>
                                        <li>Emotional disturbances - Anxiety</li>
                                        <li>Depression disorders</li>
                                        <li>Panic attacks</li>
                                        <li>Trauma</li>
                                        <li>Grief</li>
                                        <li>Workspace related issues</li>

                                    </ul>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>WHO NEEDS THERAPY</Accordion.Header>
                                <Accordion.Body>
                                    <p>When you arrive at conclusions about your self worth and end up questioning your decisions
                                        and relationships. Sometimes we choose to suffer in silence</p>
                                    <p>When you feel there is too much on your plate and life has too little to give. You're not at all
                                        alone , this happens to all of us at different phases of life.</p>
                                    <p>Therapy offers the opportunity to be aware and accept oneself, to heal, build and thrive. It
                                        emphasizes self exploration and lets you understand how unique you are and elements of your
                                        personality.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </Col>
                </Row>
            </Container>
            <Container fluid>
                <Row style={{ paddingTop: "30px", paddingBottom: "30px" }}><Col lg={12}><Footer /></Col></Row>
            </Container>
        </>
    );
}
export default Services;